import axios from '@/utils/axios'

// 发起申请
export const apply = data => axios({
    method: 'post',
    url: '/crm/serviceConsume/apply',
    data
})

// 发起申请
export const balanceClearApply = data => axios({
    method: 'post',
    url: '/crm/serviceConsume/balanceClearApply',
    data
})

// 预存恢复申请
export const balanceRegainApply = data => axios({
    method: 'post',
    url: '/crm/serviceConsume/balanceRegainApply',
    data
})
// 卡项恢复申请
export const serviceRegainApply = data => axios({
    method: 'post',
    url: '/crm/serviceConsume/serviceRegainApply',
    data
})




  
// 查看审核记录流程
export const auditDetail= data => axios({
    method: 'post',
    url: '/crm/serviceConsume/auditDetail',
    data
})

//审核-店长-市场经理-财务
export const audit= data => axios({
    method: 'post',
    url: '/crm/serviceConsume/audit',
    data
})

//获取三无顾客列表
export const customerList= data => axios({
    method: 'post',
    url: '/crm/serviceConsume/getCustomerList',
    data
})


//申请列表
export const applyList= data => axios({
    method: 'post',
    url: '/crm/serviceConsume/applyList',
    data
})

//撤销申请-暂定
export const cancelApply= data => axios({
    method: 'post',
    url: '/crm/serviceConsume/cancelApply',
    data
})







